import AuthRightBg from './AuthRightBg';

export default AuthRightBg;
